/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ImportParticipantInRole } from './importParticipantInRole';

export interface ImportParticipantIn {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  role?: ImportParticipantInRole;
  is_me?: boolean;
}
